import { Divider, Typography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { useStyles } from './HeaderWrapper.styles'

type HeaderRootState = {
  loading: Record<string, number>
  appAlert: { sidePanelAlert?: boolean }
}

type HeaderWrapperProps = {
  title?: string
  titleIcon?: React.ReactNode
  actions?: React.FC
  pageYOffset?: number
  hideTitle?: boolean
}

export const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
  title,
  actions: Actions,
  titleIcon,
  pageYOffset = 0,
  hideTitle = false,
}) => {
  const [isSticky, setIsSticky] = useState(false)
  const titleHeaderEl = useRef<HTMLDivElement>(null)
  const loading = useSelector((state: HeaderRootState) =>
    Object.values(state.loading).some((count: number) => count > 0)
  )
  useSelector((state: HeaderRootState) => state.appAlert.sidePanelAlert)
  useEffect(() => {
    if (titleHeaderEl && titleHeaderEl.current) {
      const offsetTopElement = titleHeaderEl.current.offsetTop

      if (pageYOffset > offsetTopElement) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }
  }, [titleHeaderEl, pageYOffset])

  const { classes } = useStyles()
  return (
    <>
      {!hideTitle && (
        <div
          className={clsx(classes.titleHeader, classes.stickyContainer)}
          data-testid="title-actions"
        >
          <div className={classes.appTitle}>
            <div className={classes.appTitleHeading}>
              {title ? (
                <>
                  <div className={classes.appTitleIcon}>{titleIcon}</div>
                  <Typography
                    variant="h1"
                    data-testid="heading"
                    className={classes.appTitleHeadingText}
                  >
                    {title}
                  </Typography>
                </>
              ) : null}
            </div>
            <div data-testid="actions" className={classes.appTitleActions}>
              {Actions ? <Actions /> : null}
            </div>
          </div>
          <Divider className={classes.divider} />
        </div>
      )}
      <div
        className={
          isSticky
            ? clsx(classes.titleHeader, classes.sticky)
            : classes.fixedContainer
        }
        ref={titleHeaderEl}
      >
        {loading && (
          <div className={clsx(classes.progressRoot)}>
            <LinearProgress
              data-testid="progressBar"
              classes={{
                barColorPrimary: classes.barColorPrimary,
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}
